import clsx from 'clsx';
import React, { ReactNode } from 'react';
import logo from 'common-assets/assets/images/logo-light.svg';
import ContactMenu from './ContactMenu/ContactMenu';
import { useTranslation } from 'react-i18next';

import useStyles from './Header.style';

export enum HeaderType {
  BeforeLogin = 'before-login',
  Creator = 'creator',
  CreatorFundDetails = 'creator-fund-details',
  Process = 'process',
  AfterLogin = 'after-login',
  FundCard = 'fund-card'
}

export interface HeaderProps {
  headerType: HeaderType;
  className?: string;
  children?: string | ReactNode;
  renderLogo?: (logo: JSX.Element, linkClassName: string) => JSX.Element;
}

const LogoBox: React.FC = () => {
  const [t] = useTranslation('header');
  return (
    <img
      alt={t('logo.ingTfiLogoAlternativeText')}
      src={logo}
      width={110}
      height={36}
    />
  );
};

const Header: React.FC<HeaderProps> = ({
  children,
  headerType = HeaderType.Creator,
  className,
  renderLogo
}) => {
  const c = useStyles({
    headerType,
    showContact: true,
    showPurchase: false,
    showPersonal: false,
    showLanguageSwitch: false,
    disableLogoLink: false,
    showPricing: false,
    height: 0,
  });

  const logoElement = <LogoBox />;

  return (
    <div className={clsx({
      [c.root]: true,
      [c.rootCreatorFundDetails]: headerType === HeaderType.CreatorFundDetails,
    })}>
      <div className={clsx({
        [c.appbar]: true,
        [c.appBarCreatorFundDetails]: headerType === HeaderType.CreatorFundDetails,
        className,
      })} data-testid={'application-bar'}>
        <div className={clsx(c.logoBox, 'Header__logoBox')}>
          {renderLogo ? renderLogo(logoElement, c.link) : logoElement}
        </div>
        <div className={c.innerNav}>
          <ContactMenu headerType={headerType} />
          {children}
        </div>
      </div>
    </div>
  );
};

export default Header;
